export const ASSETS_BASE_URL = "https://assets.wonmov.com/";

/** Direct upstream URL — used only outside the browser (e.g. build-time fallbacks). */
export const REMOTE_API_BASE_URL = "https://api.wonmov.com/api/";

/** Same-origin path proxied by webpack-dev-server and production nginx. */
export const PROXY_API_BASE_URL = "/api/";

export function getApiBaseUrl(): string {
  return REMOTE_API_BASE_URL;
}